import _remove from 'lodash/remove';

export default class ListStudentController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    groups,
    GroupService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.groups = groups;
    this.GroupService = GroupService;

    this.students = [];
    _remove(this.groups, group => group.default);
  }

  loadStudents() {
    this.GroupService.getStudents(this.selectedGroupId, true).then(result => {
      this.students = result;
      if (this.students.length === 0) {
        this.emptyGroup = true;
      } else {
        this.emptyGroup = false;
      }
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać uczniów z grupy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step3');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
